
export default {
  print: {
    print: 'Ausdrucken',
    segment: 'Abschnitt',
    preparingPrinting: 'Ausdruck vorbereiten',
    readyToPrint: 'Bereit zum Drucken'
  }
}
